import FashBusinessesContainer from "./FashBusinessesContainer";
import ViewMoreContainer from "./ViewMoreContainer";

export { FashBusinessesContainer, ViewMoreContainer };
